module.exports = __webpack_public_path__ + "img/2E4213.d8d52cea.svg";